<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" style="position:relative;">
          <div class="x-button" @click="$emit('close')">&times;</div>
          <div style="position: absolute;top: 4px;width: 100%;display: flex;left: 0px;justify-content: center;">
            <button @click="deviceToggle = 'desktop'" style="margin-right: 10px;">Desktop</button>
            <button @click="deviceToggle = 'mobile'" style="margin-right: 10px;">Mobile</button>
            <button @click="deviceToggle = 'amp'">AMP</button>
          </div>
          <div class="modal-body" style="min-height: calc(98vh - 115px);">
            <slot name="body">
              <iframe v-if="deviceToggle == 'desktop'" :src="previewUrl + slug + '/' + password  + '/'" style="width: 1280px;height: calc(98vh - 115px);margin: 20px auto;display: block;"></iframe>
              <iframe v-if="deviceToggle == 'mobile'" :src="previewUrl + slug + '/' + password + '/'" style="width: 400px;height: 800px;margin: 20px auto;display: block;"></iframe>
              <iframe v-if="deviceToggle == 'amp'" :src="previewUrl + slug + '/' + password + '/amp/'" style="width: 400px;height: 800px;margin: 20px auto;display: block;"></iframe>
              
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <span style="width:700px;">
                <button @click="copyText();">COPY</button>
                <input id="previewText"/>
              </span>

              <button class="modal-default-button" @click="$emit('close')">Done</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Vue from "vue";
import firebase from "firebase";
import ModalButton from "../ModalButton.vue";
import config from "../../config.json";
require("firebase/firestore");

export default {
  name: "modal",
  props: ["slug","password"],
  components: {
      ModalButton
  },
  data: function() {
    return {
      previewUrl: config.previewUrl,
      deviceToggle: "desktop"
    };
  },
  mounted: function() {
    document.getElementById("previewText").value = 'https://mamamia-pwa-staging.firebaseapp.com/article-preview/' + this.slug + '/' + this.password + '/';
  },
  methods: {
    copyText: function() {
      document.getElementById('previewText').select();
      document.execCommand('copy');
    }
  }
};
</script>

<style scoped>
#previewText {
  width:600px;
  border:0;
  color:white;
  background-color:transparent;
}
iframe {
  background-color:white;
}
.x-button {
  margin-left: auto;
  cursor: pointer;
  font-size: 30px;
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 99999;
}
.modal-mask {
  overflow-y: scroll;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
img {
  max-width: 300px;
}
.flex1 {
  margin-left: 5px;
}
.flex1 h2 {
  margin: 0;
  border: none;
}
.flex1 p {
  margin: 3px 0 3px 0;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  height: 98vh;
  color: black;
  display: flex;
  flex-direction: column;
  max-width: 1400px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #5f5f5f;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}
  .md-content {
    max-width: 100%;
        padding: 10px;
    overflow: auto;
  }

/* .modal-default-button {

} */
.modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding: 5px;
}
.modal-footer button {
  margin: 0 5px;
  height: 30px;
}
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media screen and (min-width: $responsive_breakpoint_min) {
  .scrolling-wrapper-flexbox {
    scroll-behavior: smooth;
    overflow-x: hidden;
  }
}
@media screen and (max-width: $responsive_breakpoint_max) {
  .scrolling-wrapper-flexbox {
    overflow-x: scroll;
  }
  .video-scroll-button {
    display: none !important;
  }
}
.scrolling-wrapper-flexbox {
  display: flex;
  flex-wrap: nowrap;

  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
}

.card {
  border: 1px solid white;
  width: 150px;
  flex: 0 0 auto;
  margin-right: 3px;
}
.card img {
  width: 150px;
}

.video-block {
  position: relative;
  margin-left: 20px;
  max-width: 300px;
}

input {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// articlePreview.vue?c133f2ae